import React, { useState } from "react";

import { User } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { UserContext } from "./user-context";
import UserTemplatesAndInspectionsListContextWrapper from "./user-templates-and-inspections-context-wrapper";

interface UserContextWrapperProps {
  children: React.ReactNode;
}

const UserContextWrapper = ({ children }: UserContextWrapperProps) => {
  const [user, setUser] = useState<User>(new User());
  const userContextValue = { user, setUser };

  return (
    <UserContext.Provider value={userContextValue}>
      <UserTemplatesAndInspectionsListContextWrapper>
        {children}
      </UserTemplatesAndInspectionsListContextWrapper>
    </UserContext.Provider>
  );
};

export default UserContextWrapper;
